<template>
    <div class="dashboard">
        <div class="l-2-00-t--all l-mb3">
            <div>
                <h1>配車</h1>
            </div>
            <div>
                <input v-model="params.date" class="l-w4" type="date" @change="fetchingListDeliveryDestinations()">
            </div>
        </div>
        <table>
            <tr>
                <th>
                    &nbsp;
                </th>
                <th v-for="data in tableSet" :key="data.key" :class="data.class">
                    {{ data.head }}
                </th>
                <th class="is-right">&nbsp;</th>
            </tr>
            <tr v-for="(list, index) in listDeliveryDestinations" :key="`list${index}`">
                <td>
                    {{ index + 1 }}
                </td>
                <template v-for="data in tableSet">
                    <td v-if="data.key === 'vehicle_id'" :key="`list${index}${data.key}`" :class="data.class">
                        <select v-model="input[list.id].vehicle_id" @change="setVehicle(list.id)">
                            <option value="">選択してください</option>
                            <option v-for="(option, vehicleIndex) in listVehicles" :key="`vehicle${vehicleIndex}`" :value="option.vehicle_id">{{ option.vehicle_id }}</option>
                        </select>
                    </td>
                    <td v-else-if="data.key === 'driver_name'" :key="`list${index}${data.key}`" :class="data.class">
                        <select v-model="input[list.id].driver_id">
                            <option value="">選択してください</option>
                            <option v-for="(option, driverIndex) in listDrivers" :key="`driver${driverIndex}`" :value="option.driver_id">{{ option.driver_name }}</option>
                        </select>
                    </td>
                    <td v-else-if="data.key === 'delivery_allocations_amount'" :key="`list${index}${data.key}`" :class="data.class">
                        <input v-model="input[list.id].delivery_allocations_amount" type="number" max="999999999.9" min="0.01" step="0.01">
                    </td>
                    <td v-else-if="data.key === 'forbidden_time_flag'" :key="`list${index}${data.key}`" :class="data.class">
                        {{ list[data.key] | changeFormatValue }}
                    </td>
                    <td v-else :key="`list${index}${data.key}`" :class="data.class">
                        {{ list[data.key] }}
                    </td>
                </template>
                <td class="is-right">
                    <button :class="`${classButtonStyle}other`" type="button" @click="handleCreate(list.id)">決定</button>	
                    <router-link :class="`${classButtonStyle}primary`" :to="{ name: 'offices_delivery_destinations_update', params: { id: String(list.id) }}" type="button" tag="button">変更</router-link>
                    <button :class="`${classButtonStyle}delete`" type="button" @click="setDeleteId(list.id)">削除</button>
                </td>
            </tr>
        </table>
        <Modal :modal="modal" @action="modalAction($event)" @close="$_modalClose()" />
    </div>
</template>

<script>
    "use strict";

    import common from "@/mixins/common";

    const tableDeliveryDestinations = [
        {
            "class": "is-wrap",
            "head": "施工業者",
            "key": "contractor",
        },
        {
            "class": "is-wrap",
            "head": "現場名",
            "key": "delivery_destination_name",
        },
        {
            "class": "",
            "head": "車両ID",
            "key": "vehicle_id",
        },
        {
            "class": "",
            "head": "ドライバー",
            "key": "driver_name",
        },
        {
            "class": "",
            "head": "納入量（㎥）",
            "key": "delivery_allocations_amount",
        },
        {
            "class": "is-center",
            "head": "大禁時間帯",
            "key": "forbidden_time_flag",
        },
    ];

    export default {
        "filters": {
            changeFormatValue(val) {
                // valueの表示形式を変更
                if (val === "1") {
                    return "〇";
                } else {
                    return "";
                }
            },
        },
        "mixins": [
            common,
        ],
        data() {
            return {
                "classButtonStyle": "button--",
                "deleteItemId": "",
                "listDeliveryDestinations": [],
                "listDrivers": [],
                "listVehicles": [],
                "input": {},
                "params": {
                    "date": "",
                },
                "sync": {
                    "drivers": "",
                    "vehicles": "",
                },
                "tableSet": tableDeliveryDestinations,
            };
        },
        async created() {
            this.setDate();
            this.fetchingListDrivers();
            this.fetchingListVehicles();
            const drivers = await this.sync.drivers;
            const vehicles = await this.sync.vehicles;
            this.fetchingListDeliveryDestinations(drivers, vehicles);
        },
        "methods": {
            modalAction(key) {
                if (key === "deleteDeliveryDestinations") {
                    this.handleDelete();
                } else if (key === "deleteDeliveryDestinations--finished") {
                    this.$_modalClose();
                    this.fetchingListDeliveryDestinations();
                }
            },
            setDate() {
                // 今日の日付をset
                const today = new Date();
                const year = today.getFullYear();
                const month = ("0" + (today.getMonth() + 1)).slice(-2);
                const date = ("0" + today.getDate()).slice(-2);
                this.params.date = `${year}-${month}-${date}`;
            },
            setVehicle(id) {
                const driverName = this.setVehicleSizeName(id);
                this.setDriver(id, driverName);
            },
            setVehicleSizeName(id) {
                // inputに車両サイズ名をset
                for (let data of this.listVehicles) {
                    if (data.vehicle_id === this.input[id].vehicle_id) {
                        this.input[id].vehicle_size_name = data.vehicle_size_name;
                        // ついでに車両のメインドライバーを返す
                        return data.driver_name;
                    }
                }
            },
            setDriver(id, driverName) {
                for (let data of this.listDrivers) {
                    if (data.driver_name === driverName) {
                        this.input[id].driver_id = data.driver_id;
                    }
                }
            },
            fetchingListDrivers() {
                // 全ドライバーデータ取得
                this.sync.drivers = common.$_axios.get(
                    `${common.$_configs.apiUrl}/drivers`,
                    this.$_requestConfig()
                ).then(response => {
                    // ドライバーIDで昇順
                    this.listDrivers = response.data.sort((a, b) => a.driver_id - b.driver_id);
                }).catch(() => {
                    this.$_modalError("fetchingDriversError");
                });
            },
            fetchingListVehicles() {
                // 全車両データ取得
                this.sync.vehicles = common.$_axios.get(
                    `${common.$_configs.apiUrl}/vehicles`,
                    this.$_requestConfig()
                ).then(response => {
                    // 車両IDで昇順
                    this.listVehicles = response.data.sort((a, b) => a.vehicle_id - b.vehicle_id);
                }).catch(() => {
                    this.$_modalError("fetchingVehiclesError");
                });
            },
            fetchingListDeliveryDestinations() {
                this.$_requestCancel("SelectDate");
                // 全納入先データ取得
                common.$_axios.get(
                    `${common.$_configs.apiUrl}/delivery_destinations`,
                    this.$_requestConfig("SelectDate")
                ).then(response => {
                    // 納入先IDで昇順
                    this.listDeliveryDestinations = response.data.sort((a, b) => a.id - b.id);
                    this.input = {};
                    // inputの初期値をset
                    const inputValue = {
                        "delivery_destination_id": "",
                        "delivery_destination_date": this.params.date,
                        "vehicle_id": "",
                        "vehicle_size_name": "",
                        "driver_id": "",
                        "delivery_destination_name": "",
                        "contractor": "",
                        "delivery_allocations_amount": "",
                        "factory_departure_time": "",
                    };
                    for (let i in this.listDeliveryDestinations) {
                        let id = this.listDeliveryDestinations[i].id;
                        const obj = Object.assign({}, inputValue);
                        this.$set(this.input, id, obj);
                        this.input[id].delivery_destination_id = id;
                        this.input[id].delivery_destination_name = this.listDeliveryDestinations[i].delivery_destination_name;
                        this.input[id].contractor = this.listDeliveryDestinations[i].contractor;
                    }
                }).catch(() => {
                    this.$_modalError("fetchingDeliveryDestinationsError");
                });
            },
            handleCreate(id) {
                if (this.input[id].vehicle_id && this.input[id].driver_id && this.input[id].delivery_allocations_amount && 0.01 <= this.input[id].delivery_allocations_amount && this.input[id].delivery_allocations_amount <= 999999999.9) {
                    // 個別納入割当データ追加
                    common.$_axios.post(
                        `${common.$_configs.apiUrl}/delivery_allocations`,
                        this.input[id],
                        this.$_requestConfig()
                    ).then(() => {
                        this.$router.push({ "name": "offices_delivery_allocations_list" });
                    }).catch(() => {
                        this.$_modalError("createDeliveryAllocationsError");
                    });
                } else {
                    alert("入力値が正しくありません。");
                }
            },
            setDeleteId(id) {
                // 削除IDをset
                this.deleteItemId = id;
                this.$_modalOpen("deleteDeliveryDestinations");
            },
            handleDelete() {
                // 個別納入先データ削除
                common.$_axios.delete(
                    `${common.$_configs.apiUrl}/delivery_destinations/${this.deleteItemId}`,
                    this.$_requestConfig()
                ).then(() => {
                    this.$_modalFinished();
                }).catch(() => {
                    this.$_modalError();
                });
            },
        },
    };
</script>

<style lang="scss" scoped>
    .is-wrap {
        min-width: 160px;
    }
</style>
